import React from 'react';

import { Title, Value, Wrapper } from './styled';

type Props = {
  name?: string;
  email?: string;
};

const UserInfo = ({ name, email }: Props): JSX.Element | null => {
  if ((!name || name === ' ') && !email) {
    return null;
  }

  return (
    <Wrapper data-testid="userInfo">
      {!!name && (
        <div data-testid="name">
          <Title>Name: </Title>
          <Value>{name}</Value>
        </div>
      )}
      {!!email && (
        <div data-testid="email">
          <Title>Email: </Title>
          <Value>{email}</Value>
        </div>
      )}
    </Wrapper>
  );
};

export default UserInfo;
